import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    arrow: 'absolute top-0 bottom-0 w-[30%]',
    arrowPrev: 'left-0',
    arrowNext: 'right-0'
  }
});
